// extracted by mini-css-extract-plugin
module.exports = {"client":"styles_client__2QTCq","icon":"styles_icon__m8yUB","data":"styles_data__1cR4k","title":"styles_title__2HUao","type":"styles_type__MSvL_"};